
export class InvitationConst {
    public static INVITE_DIALOG: string = "INVITE_DIALOG";
    public static COPIED_TO_CLIPBOARD: string = "COPIED_TO_CLIPBOARD";
    public static EXTERNAL_DIALOG: string = "EXTERNAL_DIALOG";
    public static INVITE_SENT: string = "INVITE_SENT";
    public static INVITE_SUCCESS: string = "INVITE_SUCCESS";
}

